module.exports = __webpack_public_path__ + "static/meadows-thumbnail-705eb0cc7cd2d139d26abc75dc43e580.jpg";